import { render } from "./Venues.vue?vue&type=template&id=476b3b4e"
import script from "./Venues.vue?vue&type=script&lang=js"
export * from "./Venues.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__